import styled from 'styled-components';

export const SliderAvatarEmployeesSkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 4px 35px;
`;

export const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70px;
`;
